import { memo, useEffect, useMemo, useState } from "react";
import { Grid, Loader, Select } from "semantic-ui-react";
import FetchAPI from "../../../../../api/FetchAPI";
import { useSelector } from "react-redux";
import { getCurrentProjectID } from "../../../../../app_shared_functions";
import { getProjectsObject } from "../../../../../selectors/projects";
import { Network } from "../../../../../api/resources/Networking/Networks";
import { NO_EXTERNAL_CONNECTION_TEXT } from "../constants";
import { HandleSelectChange } from "../../../../../custom-hooks/form/types";
import { useNetworkFormContext } from "../context/NetworkFormContext";

type ExternalConnectionProps = {
  onChange: HandleSelectChange;
  externalNetworkId?: string;
};

const ExternalConnection = ({
  onChange,
  externalNetworkId,
}: ExternalConnectionProps) => {
  const { formData, predefined_params } = useNetworkFormContext();
  const region = formData.region || predefined_params?.region;

  const projects = useSelector(getProjectsObject);
  const projectId = getCurrentProjectID(projects, region) || "";

  const [loading, setLoading] = useState(true);
  const [externalNetworks, setExternalNetworks] = useState<Network[]>([]);

  useEffect(() => {
    setLoading(true);
    if (!region) return;
    FetchAPI.Networking.Networks.getList({
      region,
      project_id: projectId,
    })
      .then((res) => {
        const ext = res.data.filter((net) => net["router:external"] === true);
        setExternalNetworks(ext);
      })
      .finally(() => setLoading(false));
  }, [projectId, region]);

  const options = useMemo(() => {
    const mappedNetworks = externalNetworks.map((net, i) => ({
      key: i,
      value: net.id,
      text: net.name,
    }));
    mappedNetworks.push({
      key: externalNetworks.length + 1,
      value: NO_EXTERNAL_CONNECTION_TEXT,
      text: NO_EXTERNAL_CONNECTION_TEXT,
    });
    return mappedNetworks;
  }, [externalNetworks]);

  return (
    <Grid.Row>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-bottom"
      >
        <h5>External Network</h5>
      </Grid.Column>
      <Grid.Column
        textAlign="left"
        width={8}
        className="flex vcenter margin-bottom"
      >
        {loading ? (
          <div className="loader-wrapper">
            <Loader size="mini" active className="one-liner ">
              Fetching Network list...
            </Loader>
          </div>
        ) : externalNetworks.length === 0 ? (
          "No network"
        ) : (
          <Select
            icon="chevron circle down"
            className="select-box full"
            placeholder="Choose external network"
            options={options}
            value={externalNetworkId}
            name="externalNetworkId"
            onChange={onChange}
          />
        )}
      </Grid.Column>
    </Grid.Row>
  );
};

export default memo(ExternalConnection);
